import type { FaireProductEntity } from "../../entity_types/product";

export const p_dvgcvw26kb: FaireProductEntity = {
  token: "p_dvgcvw26kb",
  type: "product",
  name: "Blown Glass Small Ornament - Garland",
  brandToken: "b_bzqgcv5hnl",
  brandName: "Dandarah (Ships from Canada)",
  imageUrl:
    "https://cdn.faire.com/fastly/57120b38e6a063b115c35d1f7128c2bd88172ce00ffe5ae8a066b188342fdb3f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7901bd524464a4836ea2f01caccdaedddc91fbdba5014abf0f69257eecb728d0.jpeg",
    "https://cdn.faire.com/fastly/a789e12075e40ff0e577c40c975ce4b2c6946e31619aa9d8eba8a7094dbd22d2.jpeg",
    "https://cdn.faire.com/fastly/0caefc02612e7c6441d11ef32c14aa5c769e02fd387bcd145771ae01795150da.jpeg",
    "https://cdn.faire.com/fastly/e77d23e0ba961da70837ce43abca4112c978596cd23f5b6eeec6a176c6a33773.jpeg",
    "https://cdn.faire.com/fastly/7090d219882f03b0f1830c74a76dc2d5ad0ae80409739eb9cd6d9d69773ee165.jpeg",
    "https://cdn.faire.com/fastly/7bd191015a7755635f9f311165fddfadee59b938b25329fc6f92fec7eb558c2a.jpeg",
    "https://cdn.faire.com/fastly/105201f15ff5a8699240c0c6b303583581a171ae48e542e0d3c82befd73ba9b5.jpeg",
    "https://cdn.faire.com/fastly/f8ddb4bca1bf2773d787a80b56c42129ac9c17f0e784698153cc72a7e5fba4c1.jpeg",
    "https://cdn.faire.com/fastly/8fd6bdaf79f4758bbc494b83ef6c2f09208d1ace9022a5a1fccef9dfafa087a7.jpeg",
    "https://cdn.faire.com/fastly/e400d2726e0d76c151f31144bced0544788aa75a00374b597667b79576656ce9.jpeg",
    "https://cdn.faire.com/fastly/4db768939e4358aa052ce3c9866c7c28958faae2552ae6b47d4f50bb20488401.jpeg",
    "https://cdn.faire.com/fastly/84a04e80d3cfcf19da2dbe8d916350e3a93f4a7c59a9307456ba3084386081b5.jpeg",
    "https://cdn.faire.com/fastly/384c1d1990e68a25ee8662c78131b023e0957b8fa3c50b81da50778822f98a30.jpeg",
    "https://cdn.faire.com/fastly/17b9118f99a7cd255abbd940cfed8fe281eb578cee111358d24da6400e6f21ff.jpeg",
    "https://cdn.faire.com/fastly/449debc3841c325e9173653258e48d5c44d1cc8186e4eaecb6960a2a2333df9a.jpeg",
    "https://cdn.faire.com/fastly/203014c5c37aa18872eeb305fe6ca77be877cb4b707ea0e5140a0fcf2f14d6c8.jpeg",
    "https://cdn.faire.com/fastly/721a5154cff56736aab0c274b221fa92e10522481630dcfef3fdd142e073857b.jpeg",
    "https://cdn.faire.com/fastly/46f6037d2f8aeebae40821caaf5287f3b4b4cf7279c59aafc0f5b44494d32004.jpeg",
    "https://cdn.faire.com/fastly/ea5f040c0031d0342fc117ae9ffdcd1005b1c9a4d543f711c81371e7bb705174.jpeg",
  ],
  priceDollars: 12.5,
  description:
    'Add a hint of beauty with these unique handmade blown glass ornaments; as home decor, Christmas decoration, and much more. Artfully created by skilled glass blowers in the heart of old Cairo, Egypt. The art of glass blowing began in Egypt at least in the 3rd century A.D. based on a poem written on papyrus that describes the technique.\n\n• Dandarah’s blown glass products are designed to be functional, while preserving the artisans’ traditional techniques.\n• Fair trade.\n• Decorated by hand. Hand painted with gold.\n• Borosilicate glass.\n• Approx. 5 cm / 2" in diameter.\n• Due to the nature of hand-blown glass size and color may vary slightly from one piece to another.\n• Fulfillment and shipment from Canada.',
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:43.768Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
